import type { Card } from "@amzn/ads-blink-client";
import type { ContentInfo } from "@amzn/ads-phoenix-type-script-client";
import { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";

import { unifiedFilterStore } from "../store/unifiedFilters";

/**
 * Extracts Phoenix ContentInfo from a Card object
 * See mapping: https://tiny.amazon.com/ei51wq0d/codeamazpackAdsBblobheadmain
 */
export const getPhoenixContentInfo = (card?: Card): ContentInfo => {
    const topic = card?.additionalInfo?.["topic"];
    const contentType =
        {
            [InsightType.INSIGHT]: card?.details?.metadata?.["familyName"],
            [InsightType.MARKETING]: topic,
            [InsightType.PACKAGING]: topic,
            [InsightType.PITCHED_CONTENT]: "Client Presentations",
            [InsightType.CDB_TEMPLATE]: topic,
        }[card?.insightType ?? "Unknown"] ?? "Unknown";

    return {
        contentProvider: card?.insightType ?? "Unknown",
        contentType,
        contentId: card?.identifier ?? "Unknown",
    };
};

/**
 * Retrieves content from the unified filter store and converts it to Phoenix ContentInfo
 */
export const getPhoenixContentInfoFromStore = (
    provider?: InsightType,
    id?: string,
): ContentInfo => {
    const card = unifiedFilterStore
        .getState()
        .getContent(provider ?? "Unknown", id ?? "Unknown");
    return getPhoenixContentInfo(card);
};
